<form [formGroup]="Form">
	<ion-item class="ion-margin-end" fill="outline">
		<ion-label i18n=":@@budget.component-title">Orçamento</ion-label>
		<ion-select [interface]="'popover'" class="select-items" formControlName="edition">
			<ion-select-option *ngFor="let item of Editions" [value]="item">{{ item.Name }}</ion-select-option>
		</ion-select>
	</ion-item>
</form>